/**
 * Message registry — maps each supported locale to its message tree.
 *
 * To add a new locale:
 *   1. Create `messages/<locale>.ts` with the same shape as `en.ts`.
 *   2. Import it here and add an entry to `messageRegistry`.
 *   3. Add the locale string to the `Locale` union in `../types.ts`.
 *   4. Add the locale to `SUPPORTED` in `../resolveLocale.ts`.
 */
import en from './en';
import fr from './fr';
import es from './es';
import type { Locale, MessageTree } from '../types';

export const messageRegistry: Record<Locale, MessageTree> = {
    en,
    fr,
    es
};
